import { getProgressColorVar, ProgressColor } from '@lyra/core/utils/progress'
import React from 'react'
import { Stack, useTheme } from 'tamagui'

export type ProgressProps = {
  percentComplete: number
  color?: ProgressColor
  size: number
}

const ProgressCircle = ({
  percentComplete: _percentComplete,
  color = 'primary',
  size,
}: ProgressProps) => {
  const percentComplete = Math.max(Math.min(_percentComplete, 1), 0) * 100 // bound between 0 and 1

  const theme = useTheme()
  const hairlineColor = theme.hairline?.get()
  const circleStrokeWidth = 3

  const outerRadius = Math.floor(size / 2)
  const innerRadius = outerRadius - circleStrokeWidth / 2

  return (
    <Stack width={size} height={size}>
      <Stack width={'100%'} height={'100%'} zIndex={1} position="absolute">
        <svg
          width={outerRadius * 2}
          height={outerRadius * 2}
          style={{ transform: 'scale(1,1) rotate(-90deg)' }}
        >
          <circle
            cx={outerRadius}
            cy={outerRadius}
            r={innerRadius}
            strokeWidth={circleStrokeWidth}
            stroke={theme[getProgressColorVar(color)]?.val?.toString()}
            fill="none"
            style={{
              strokeDasharray: 100,
              strokeDashoffset: 100 - percentComplete,
            }}
            pathLength={100}
          />
        </svg>
      </Stack>
      <Stack width={'100%'} height={'100%'} zIndex={0} position="absolute">
        <svg
          width={outerRadius * 2}
          height={outerRadius * 2}
          style={{ transform: 'scale(1,1) rotate(-90deg)' }}
        >
          <circle
            cx={outerRadius}
            cy={outerRadius}
            r={innerRadius}
            strokeWidth={circleStrokeWidth}
            stroke={hairlineColor}
            fill="none"
            pathLength={100}
          />
        </svg>
      </Stack>
    </Stack>
  )
}

ProgressCircle.displayName = 'ProgressCircle'

export default ProgressCircle
